import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SHOWCASE } from "../data/content";
import { usePageMeta } from "../hooks/use-page-meta";
import { track } from "../lib/tracking";

export default function Events() {
  usePageMeta(
    "Events We Support | Celebrity Bouncers",
    "Weddings, celebrity appearances, corporate launches, concerts, showroom openings, public gatherings and private VIP celebrations across AP & Telangana."
  );
  return (
    <>
      <PageHero
        testid="events-page-hero"
        eyebrow="Events"
        title="Occasions We Quietly Stand Behind"
        description="Every category of event carries its own rhythm. Our teams are briefed, positioned and dressed for yours."
      />
      <section className="container-x py-20 sm:py-28" data-testid="events-page-list">
        <div className="grid gap-5 md:grid-cols-2">
          {SHOWCASE.map((item, i) => (
            <Reveal key={item.id} delay={(i % 2) * 0.08}>
              <Link
                to="/portfolio"
                data-testid={`event-card-${item.id}`}
                onClick={() => track("portfolio_view", { item: item.id, placement: "events" })}
                className="group relative block h-80 overflow-hidden sm:h-96"
              >
                <img
                  src={item.img}
                  alt={item.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1.8s] ease-out group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/95 via-obsidian/30 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-7">
                  <p className="eyebrow">{item.category}</p>
                  <div className="mt-3 flex items-center justify-between gap-4">
                    <h2 className="font-serif text-2xl font-medium text-ivory sm:text-3xl">{item.title}</h2>
                    <ArrowUpRight size={20} className="shrink-0 text-gold transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>
                  <p className="mt-2 flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-steel">
                    <MapPin size={12} className="text-gold" /> {item.city}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {item.services.map((s) => (
                      <span key={s} className="border border-ivory/20 px-2.5 py-1 text-[10px] uppercase tracking-[0.15em] text-ivory/70">
                        {s}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-8">
          <p className="text-xs italic text-steel/60">
            Representative sample entries. Real event details and photographs are published only with client permission.
          </p>
        </Reveal>
        <Reveal className="mt-12">
          <Link
            to="/contact"
            data-testid="events-page-enquire-btn"
            className="inline-block bg-gold px-8 py-4 text-[13px] font-bold uppercase tracking-[0.2em] text-obsidian transition-colors duration-300 hover:bg-gold-soft"
          >
            Discuss Your Event Privately
          </Link>
        </Reveal>
      </section>
    </>
  );
}
